import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { handleError } from "utils";
import axios from "axios";

const useCheckBalance = () => {
  const [balance, setBalance] = useState();

  const { isLoggedIn } = useSelector((s) => s.auth);

  let res;

  const checkBalance = async () => {
    try {
      res = await axios.get(`/wallet`);
      setBalance(res?.data?.data?.balance);
    } catch ({ response }) {
      handleError(response);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      checkBalance();
    }
  }, [isLoggedIn]);

  return [balance];
};

export default useCheckBalance;
